import React, { useMemo } from 'react';
import { mkNode, mkEdge, FlowCanvas } from './flowParts';

// Color per logical tier (mirrors the Costs INFRA_SPECS groups).
const C = {
  client: '#9aa0a6',
  web: '#14e0c8',
  firebase: '#e0a414',
  compute: '#e0517a',
  storage: '#5b8def',
  secrets: '#9b6cf2',
  cicd: '#3fbf6f',
};

const NODES = [
  mkNode('browser', 0, 230, 'Client · Browser', 'React 18 SPA', C.client),

  mkNode('hosting', 280, 20, 'Firebase Hosting', 'chadha.surf · static app', C.web),
  mkNode('cdn', 280, 120, 'CloudFront', 'cdn.chadha.surf · HTTP/3 · OAC', C.web),
  mkNode('auth', 280, 220, 'Firebase Auth', 'Email/Password · ID tokens', C.firebase),
  mkNode('firestore', 280, 320, 'Cloud Firestore', 'realtime + job queue', C.firebase),
  mkNode('alb', 280, 430, 'Application Load Balancer', 'upload / processing API', C.compute),

  mkNode('fargate', 600, 360, 'ECS Fargate task', '8 vCPU · 16 GB · orchestrator + workers', C.compute),
  mkNode('runners', 600, 560, 'Ephemeral job runners', 'up to 32 × 8 vCPU · RED decode fan-out', C.compute),
  mkNode('efs', 920, 560, 'EFS scratch', 'shared .RDC + partial segments', C.storage),

  mkNode('s3raw', 920, 80, 'S3 · chadha-surf-raw', 'originals · full-res', C.storage),
  mkNode('s3movies', 920, 200, 'S3 · chadha-surf-movies', 'HLS · masters · derived', C.storage),
  mkNode('secrets', 920, 330, 'Secrets Mgr · SSM', 'service account · keys', C.secrets),
  mkNode('ecr', 920, 450, 'ECR', 'backend image', C.cicd),

  mkNode('codebuild', 1200, 450, 'CodeBuild', 'CI · docker build', C.cicd),
];

const EDGES = [
  mkEdge('browser', 'hosting', 'app', { animated: true, color: C.web }),
  mkEdge('browser', 'cdn', 'stream / media', { animated: true, color: C.web }),
  mkEdge('browser', 'auth', 'sign-in', { color: C.firebase }),
  mkEdge('browser', 'firestore', 'realtime r/w', { animated: true, color: C.firebase }),
  mkEdge('browser', 'alb', 'uploads / jobs', { color: C.compute }),

  mkEdge('alb', 'fargate', '', { color: C.compute }),
  mkEdge('fargate', 'firestore', 'watch / write', { animated: true, color: C.firebase }),
  mkEdge('fargate', 's3raw', 'read', { color: C.storage }),
  mkEdge('fargate', 's3movies', 'write', { color: C.storage }),
  mkEdge('fargate', 'secrets', '', { color: C.secrets }),
  mkEdge('cdn', 's3movies', 'origin (OAC)', { color: C.web }),
  mkEdge('fargate', 'runners', 'RunTask (fan-out)', { animated: true, color: C.compute }),
  mkEdge('runners', 'efs', 'decode → parts', { animated: true, color: C.storage }),
  mkEdge('runners', 's3movies', 'stitch → upload', { color: C.storage }),
  mkEdge('runners', 'firestore', 'task telemetry', { color: C.firebase }),
  mkEdge('ecr', 'runners', 'same image', { color: C.cicd }),
  mkEdge('ecr', 'fargate', 'image', { color: C.cicd }),
  mkEdge('codebuild', 'ecr', 'push', { color: C.cicd }),
];

const LEGEND = [
  ['Client', C.client],
  ['Hosting / CDN', C.web],
  ['Firebase', C.firebase],
  ['Compute', C.compute],
  ['Storage', C.storage],
  ['Secrets', C.secrets],
  ['CI/CD', C.cicd],
];

export default function InfraMap() {
  const nodes = useMemo(() => NODES, []);
  const edges = useMemo(() => EDGES, []);
  return <FlowCanvas nodes={nodes} edges={edges} legend={LEGEND} height={480} />;
}
